// removed by extract-text-webpack-plugin
module.exports = {"root":"filters--root--3bIRey7a","reset-button":"filters--reset-button--rev3SYFb","resetButton":"filters--reset-button--rev3SYFb","reset-button-items":"filters--reset-button-items--173Qn41f","resetButtonItems":"filters--reset-button-items--173Qn41f"};


//////////////////
// WEBPACK FOOTER
// ./components/filters/styles.css
// module id = ./components/filters/styles.css
// module chunks = 0